import clsx from 'clsx';
import Boto from '../Boto/Boto';
import styles from './modulmiradaglobal.module.scss';
import Icona from '../../../components/3catinfo/ui/Icona';
import { useViewport } from 'hooks/3catinfo/useViewport';

const ModulMiradaGlobal = (props) => {
    const { titol, text, textBoto, route, estil, imgFons, imgFonsMobile } = props;
    const stylesModul = clsx(styles.modulMiradaGlobal, estil && styles[estil]);
    const stylesDinsItemNoti = clsx(styles.contentModul, estil === 'noticia' && styles.itemNoticia);
    const { isMobile } = useViewport();
    const img = isMobile && imgFonsMobile ? imgFonsMobile : imgFons;
    return (
        <div className={stylesDinsItemNoti}>
            <div className={stylesModul} data-testid='newsletter' style={{ '--bg-imatge-butlleti': `url(${img})` }}>
                <div className={styles.wrapper}>
                    <div className={styles.content}>
                        <Icona inline={true} className={styles.icona} icona='sobre' ariaHidden={true} />
                        <h2 className={styles.titol} data-testid='newsletter-titol'>
                            {titol}
                        </h2>
                        <p className={styles.text} data-testid='newsletter-text'>
                            {text}
                        </p>
                        <Boto className={styles.boto} text={textBoto} route={route} tema='negre' dataTestId='newsletter-boto' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModulMiradaGlobal;
